import { Button, Toast, Tab, Tabs, Popup, Calendar, Dialog, List, Cell, PullRefresh, RadioGroup, Radio, Search, Form, Field, NavBar, Area, Slider, Icon, Image, Lazyload, Swipe, SwipeItem, Picker, Cascader, Loading, Overlay } from "vant";

export default function install(Vue) {
  Vue.use(Button);
  Vue.use(Toast);
  Vue.use(Tab);
  Vue.use(Tabs);
  Vue.use(Popup);
  Vue.use(Calendar);
  Vue.use(Dialog);
  Vue.use(List);
  Vue.use(Cell);
  Vue.use(PullRefresh);
  Vue.use(RadioGroup);
  Vue.use(Radio);
  Vue.use(Form);
  Vue.use(Field);
  Vue.use(NavBar);
  Vue.use(Area);
  Vue.use(Slider);
  Vue.use(Icon);
  Vue.use(Image);
  Vue.use(Lazyload);
  Vue.use(Swipe);
  Vue.use(SwipeItem);
  Vue.use(Picker);
  Vue.use(Cascader);
  Vue.use(Loading);
  Vue.use(Overlay);
  Vue.use(Search);
  Toast.setDefaultOptions({ duration: 1500 });
  Vue.prototype.$toast = Toast;
  Vue.prototype.$confirm = Dialog.confirm;
}
